import { BaseAgGrid } from "../grid/BaseAgGrid";
import { GridReadyEvent, SelectionChangedEvent } from "ag-grid-community";
import { useCallback, useRef } from "react";
import { Order, OrderSchema, links } from "src/app/types/orders/order";
import { useIntl } from "react-intl";
import { AgGridReact } from "ag-grid-react";
import useUpsertRDGridColumns from "./gridColumns";
import { some } from "lodash";
import { Site } from "src/app/types/Site";
import { SimpleEntityGridRest } from "../grid/SimpleEntityGridRest";
import { rdAvailable } from "src/app/types/rdAvailable";

export interface IUpsertRDOrderGrid {
    entity?: Order;
    siteList?: Array<rdAvailable>;
    handlePBNModal?(open: boolean, site: Site): void;
    setSelectedRows?: React.Dispatch<React.SetStateAction<any[]>>;
}

const UpsertRDOrderGrid = (props: IUpsertRDOrderGrid) => {
    const {
        entity = OrderSchema.getDefault(),
        siteList = [],
        setSelectedRows = () => {},
        handlePBNModal = () => {},
    } = props;
    const { formatMessage } = useIntl();
    const gridRef = useRef<AgGridReact>(null);
    const gridColumns = useUpsertRDGridColumns(handlePBNModal);
    const T = some(entity.links, (el: links) => el.url.includes(entity.moneySite?.domain))
        ? "T1"
        : "T2";
    const onSelectionChanged = (event: SelectionChangedEvent) => {
        setSelectedRows(event.api.getSelectedRows());
    };

    const doesExternalFilterPass = useCallback((): boolean => {
        return true;
    }, []);

    const resetGrid = () => {
        gridRef?.current?.api.setFilterModel({});
        gridRef?.current?.columnApi.resetColumnState();
    };

    const onGridReady = useCallback((params: GridReadyEvent) => {
        const gridApi = params.api;
        gridApi.sizeColumnsToFit();

        window.addEventListener("resize", function () {
            if (gridRef?.current?.api) {
                setTimeout(function () {
                    gridRef?.current?.api.sizeColumnsToFit();
                });
            }
        });
    }, []);

    return (
        <>
            <SimpleEntityGridRest onChange={resetGrid} />
            <b> {entity.moneySite?.pbn.name} : </b>
            {entity.moneySite?.domain} ({entity.thematic.name}) -{" "}
            <b>{formatMessage({ id: "sites.grid.col.price" })} : </b>
            {entity.orderPrice} € -{" "}
            <b>{formatMessage({ id: "content.grid.col.writingType" })} : </b>
            {entity.contentType}{" "}
            {formatMessage({
                id: `content.grid.col.writingType.${entity?.content?.writingType}`,
            })}{" "}
            - <b>{formatMessage({ id: "content.grid.col.title" })} : </b>
            {entity.content?.title} -{" "}
            <>
                <b>{formatMessage({ id: "content.grid.col.commentForLinker" })}: </b> {T} |{" "}
                {entity.commentForLinker}
            </>
            <div className="ag-theme-balham" style={{ height: "100%" }}>
                <BaseAgGrid
                    rowSelection="single"
                    listHandler={() => {}}
                    onSelectionChanged={onSelectionChanged}
                    defaultFilters={{
                        thematic: {
                            filterModels: [
                                {
                                    filter: entity.thematic.name,
                                    filterType: "text",
                                    type: "contains",
                                },
                            ],
                        },
                        price: {
                            filter: (entity.orderPrice || 0) + 10,
                            filterType: "number",
                            type: "lessThanOrEqual",
                        },
                        rd: { filter: 20, filterType: "number", type: "greaterThanOrEqual" },
                    }}
                    gridRef={gridRef}
                    rowData={siteList}
                    columnDefs={gridColumns}
                    isExternalFilterPresent={() => true}
                    onModelUpdated={() => {}}
                    doesExternalFilterPass={doesExternalFilterPass}
                    onGridReady={onGridReady}
                />
            </div>
        </>
    );
};

export default UpsertRDOrderGrid;
